import { Grid, Divider } from '@mui/material';
import { useState, useEffect } from 'react';
import { IJob } from 'wisestep-api';
import {
  WsColors,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  EmptyTeamsAndUsersIcon,
} from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard';
import Resizable from '../../../features/candidateLayout/components/childComponets/resizable/Resizable';
import useSimilarJobsFromJobSearch from '../../../features/jobs/listing/hooks/useSimilarJobsFromJobSearch';
import NoSubmissionSVG from '../../../images/NoSubmission.svg';

import CandidateListing from './components/candidateListing';
import JobsListing from './components/jobsListing';

interface LayoutProps {
  job: IJob;
}
const Layout = ({ job }: LayoutProps) => {
  const [jobs, setJobs] = useState<IJob[]>([]);
  const [selectedJobs, setSelectedJobs] = useState<IJob[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [dragValue, setDragValue] = useState<boolean>(true);
  const similarJobsFromJobSearch = useSimilarJobsFromJobSearch(job, setLoading);

  const noSimilarJobs: boolean = jobs.length === 0;

  useEffect(() => {
    setJobs(similarJobsFromJobSearch);
    if (similarJobsFromJobSearch.length > 0) {
      setSelectedJobs([similarJobsFromJobSearch[0]]);
    } else {
      setSelectedJobs([]);
    }
  }, [job, similarJobsFromJobSearch]);

  const onSelect = (job: IJob) => setSelectedJobs([...selectedJobs, job]);

  const onDeSelect = (job: IJob) => {
    if (selectedJobs.some((job) => job?.id === job?.id))
      setSelectedJobs(selectedJobs.filter((jobId) => jobId?.id !== job?.id));
    else setSelectedJobs([...selectedJobs, job]);
  };
  return (
    <Resizable
      leftPanel={
        noSimilarJobs ? (
          <Grid
            container
            rowSpacing={1}
            px={2}
            py={2.2}
            sx={{
              backgroundColor: WsColors.White,
            }}
            height="100%"
            id="leftPaneNoJobs"
          >
            <Grid item xs={12}>
              <Divider sx={{ mb: 1 }} />
              <Grid
                sx={{
                  height: '550px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                }}
              >
                <img
                  src={NoSubmissionSVG}
                  alt="No jobs ?"
                  height={130}
                  width={140}
                  style={{ marginLeft: '15px' }}
                />
                <Grid item sx={{ marginLeft: '20px' }} mt={2}>
                  <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
                    No jobs
                  </WsTypography>
                </Grid>
                <Grid item sx={{ marginLeft: '10px' }} mt={1}>
                  <WsTypography color={WsTypoColors.SECONDARY} variant={WsTypoVariants.SUB_TITLE}>
                    No Similar Jobs Found.
                  </WsTypography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <JobsListing
            jobs={jobs}
            onSelect={onSelect}
            onDeSelect={onDeSelect}
            selectedJob={selectedJobs}
            setSelectedJobs={setSelectedJobs}
          />
        )
      }
      rightPanel={
        noSimilarJobs ? (
          <Grid container sx={{ position: 'absolute', width: '100%', height: '100%' }}>
            <NoDataFoundCard
              text={'Oops! No similar jobs found for the Job.'}
              icon={<EmptyTeamsAndUsersIcon />}
              subElement={
                <Grid container p={4}>
                  <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.SECONDARY}>
                    Tip: To discover similar jobs to your current posting, we recommend providing a
                    clear job description, adding more relevant skills, and specifying the accurate
                    location. This will help you find candidates who are better matched to the job
                    more effectively.
                  </WsTypography>
                </Grid>
              }
            />
          </Grid>
        ) : (
          <CandidateListing similarJobs={selectedJobs} job={job} index={0} />
        )
      }
      defaultSizes={[25, 75]}
      minSize="20%"
      maxSize="80%"
      isLoading={loading}
      pseudoDragValue={dragValue}
      setPseudoDragValue={setDragValue}
    />
  );
};
export default Layout;
